"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translation = void 0;
var translation = {
  400: "Thank you for visiting. We are fixing this right away. Will be back soon. Meanwhile, please call +918042754444 to order your favorite Chicken.",
  401: "Thank you for visiting. We are fixing this right away. Will be back soon. Meanwhile, please call +918042754444 to order your favorite Chicken.",
  403: "Thank you for visiting. We are fixing this right away. Will be back soon. Meanwhile, please call +918042754444 to order your favorite Chicken.",
  404: "Thank you for visiting. We are fixing this right away. Will be back soon. Meanwhile, please call +918042754444 to order your favorite Chicken.",
  500: "Thank you for visiting. We are fixing this right away. Will be back soon. Meanwhile, please call +918042754444 to order your favorite Chicken.",
  501: "Thank you for visiting. We are fixing this right away. Will be back soon. Meanwhile, please call +918042754444 to order your favorite Chicken.",
  At: "at",
  No: "No",
  at: "At",
  is: "is",
  of: "of",
  xs: "xs",
  to: "to",
  noImage: "No Image",
  catering: 'Catering',
  Yes: "Yes",
  eng: "ENG",
  "for": "for",
  ga4: "GA4",
  map: "Map",
  max: "Max",
  "new": "NEW",
  phc: "restrooms for physically enabled",
  tab: "tab",
  upi: "upi",
  veg: "Veg",
  till: "till",
  from: "from",
  remove: "Remove",
  Okay: "Okay",
  asap: "ASAP",
  call: "Call",
  cart: "Cart",
  date: "Date",
  done: "Done",
  edit: "Edit",
  help: "help",
  home: "Home",
  list: "List",
  more: "More",
  noon: "NOON",
  oops: "Oops!",
  save: "Save",
  text: "Text",
  time: "Time",
  view: "View",
  when: "When",
  wifi: "wifi service",
  apply: "Apply",
  braze: "Braze",
  close: "Close",
  ecard: "ECard",
  email: "Email*",
  hours: "Hours:",
  items: "ITEMS",
  local: "en-US",
  login: "Login",
  offer: "Offer",
  order: "Order",
  payTm: "paytm",
  reset: "Reset",
  retry: "Retry",
  sorry: "Sorry,",
  timer: "timer",
  today: "Today",
  total: "Total",
  Cancel: "Cancel",
  Submit: "Submit",
  Viewed: "Viewed",
  button: "Button",
  callUs: "Call Us",
  cancel: "Cancel",
  change: "Change",
  closed: "Closed",
  custom: "custom",
  dineIn: "Dine In",
  donate: "Donate",
  expand: "expand time choices",
  goBack: "Go Back",
  inCart: "In cart",
  afterNoon: "AFTERNOON",
  kfcTxt: "KFC",
  kiosks: "kiosks",
  myCart: "My Cart",
  nonveg: "Non veg",
  redeem: "Redeem",
  refill: "refill",
  signIn: "Sign In",
  signUp: "Sign Up",
  sortBy: "Sort By",
  upSize: "Upsize your drink?",
  update: "UPDATE",
  viewed: "Viewed",
  wallet: "Wallet",
  weHave: "We have",
  zoomIn: "Zoom In",
  Payment: "Payment",
  "Sign In": "Sign In",
  account: "Account",
  addhope: "Add Hope",
  address: "Addresses",
  balance: "Balance",
  cartAdd: "increase quantity by 1 for",
  cartGst: "GST",
  checked: "Checked",
  confirm: "Confirm",
  contact: "Contact",
  cvvText: "CVV*",
  dietary: "Dietary",
  editbox: "editbox",
  editing: "editing",
  evening: "EVENING",
  findKfc: "Find A KFC",
  getHelp: "Get Help",
  heading: "heading",
  kfcMenu: "Menu",
  kfcNews: "KFC news and announcements",
  message: "Messages",
  morning: "MORNING",
  nearYou: "%storeCount% KFC near you",
  oneItem: "ITEM(S)",
  openPDP: "Open PDP",
  openPLP: "Open PLP",
  parking: "parking",
  payCash: "pay-by-cash",
  payment: "Payment",
  phonePe: "phonepe",
  receipt: "Receipt",
  signOut: "Sign Out",
  support: "SUPPORT",
  todayAt: "Today at ",
  twitter: "Twitter",
  updated: "Custom",
  validTo: "Valid to",
  viewMap: "View Map",
  weFound: "WE FOUND",
  weSaved: "We saved this order as an occasion",
  zoomOut: "Zoom Out",
  OrderNow: "Order Now",
  address2: "Address Line 2*",
  birthday: "birthday",
  carousal: "carousel view enabled",
  cartItem: "Item",
  checkBox: "checkBox",
  checkout: "CHECKOUT",
  clearAll: "Clear All",
  collapse: "collapse time choices",
  "continue": "Continue",
  delivery: "Delivery",
  dineInAt: "Dine-in At",
  editName: "Edit Favourite Name",
  emptyCvv: "Enter CVV number",
  emptyMsg: "Please enter your order name.",
  emptyPin: "Enter pin number",
  expanded: "expanded",
  external: "external",
  facebook: "Facebook",
  filterBy: "Filter By",
  freeWifi: "free wifi",
  fullName: "Full Name*",
  fullname: "fullname* editbox",
  giftCard: "Gift Card",
  internal: "internal",
  kfcImage: "kfc image",
  kfcLover: "KFC LOVER",
  listview: "listview enabled",
  loadMore: "Load More",
  mmddText: "Expiry Date (MM / YY)*",
  needHelp: "Need Help?",
  onlyText: "only text",
  orderMsg: "orci, eget tempus risus.",
  orderNow: "Order Now",
  quantity: "QUANTITY",
  readLess: "Read Less -",
  readMore: "Read More +",
  restroom: "restroom",
  savedkfc: "SAVED KFC",
  schedule: "SCHEDULE",
  selected: "selected",
  subTotal: "Subtotal",
  takeAway: "Pick up",
  takeaway: "Pick up",
  terraces: "terraces",
  tomorrow: "Tomorrow",
  tryAgain: "Please Try Again",
  viewCart: "View Cart",
  viewMenu: "View menu",
  ERROR_ALT: "error",
  EnteraCVV: "Enter CVV number",
  addCoupon: "Add a Coupon",
  addToCart: "Add to Cart",
  apiButton: "Call API",
  askForOTP: "YOUR DRIVER WILL ASK YOU FOR THIS OTP ON ARRIVAL",
  breakfast: "breakfast",
  cartItems: "Items",
  cartTitle: "CART",
  changeCap: "Change",
  collapsed: "collapsed",
  completed: "Completed",
  contactUs: "CONTACT US",
  customize: "Customise",
  doYouWant: "Do you want to",
  driveThru: "Drive Thru",
  emptyName: "Enter your Name",
  enjoyMeal: "ENJOY YOUR FINGER LICKIN' MEAL!",
  enterCode: "Enter Code",
  enterName: "Please enter name",
  foodCourt: "Food Court",
  giveAName: " give it a name!",
  greetings: "Hello",
  hometitle: "HOME",
  instaLink: "instagram link",
  instagram: "Instagram",
  leaveText: "Leave",
  leftArrow: "left arrow",
  letUsKnow: "Let us know you better",
  menuTitle: "MENU",
  moreTitle: "MORE",
  myAccount: "My Account",
  offerDeal: "Deals & Offers",
  onlyImage: "only image",
  openToday: "Open Today at",
  openUntil: "Open Until",
  orderFrom: "ORDER FROM",
  orderHash: "Order #",
  orderMode: "ORDER MODE",
  orderType: "ORDER TYPE",
  pinNumber: "Pin Number*",
  saveOrder: "Save This Order",
  scheduled: "Scheduled",
  selectDay: "SELECT A DAY",
  selectKFC: "SELECT A KFC",
  todayASAP: "Today, ASAP",
  topSeller: "TOP SELLER",
  totalCost: "Total cost:",
  unChecked: "unChecked",
  unchecked: "Unchecked",
  wantToAdd: "Want to add or modify?",
  welcomeTo: "WELCOME TO ",
  yourOrder: "Your Order",
  addACoupon: "Add a Coupon",
  arrowImage: "Arrow",
  backButton: "Back",
  backToCart: "Back to Cart",
  backToMenu: "Back to menu",
  browseMenu: "Browse Menu",
  cardExpiry: "MM / YYYY*",
  cartRemove: "Remove",
  closedNext: "Open Tomorrow",
  contactKFC: "CONTACT KFC",
  creditCard: "credit-card",
  deliveryTo: "Delivery To",
  dineInInfo: "DINE IN INFO",
  dineInText: "will be ready for Dine-in by",
  emailLabel: "Email",
  expiredMsg: "Hurry up! This exclusive coupon is expiring soon!",
  giftAmount: "GIFT AMOUNT",
  giftpinNum: "Pin Number",
  handItToMe: "Hand it to me",
  hereToHelp: "WE'RE HERE TO HELP IF YOU REQUIRE MORE INFORMATION ",
  hiddenText: "KFC | Order KFC Chicken Online & Find Restaurants",
  invalidCvv: "Invalid CVV number",
  invalidMsg: "Name must have minimum 3 and maximum 20 characters. Special characters Not allowed.",
  invalidPin: "Invalid Pin",
  isOnTheWay: "is on their way to your address",
  itemUnaval: "Items are unavailable.",
  mainEntree: "Main Entree",
  maxtextEnd: "Extra’s selected. Remove an Extra to select another.",
  myFavorite: "Favourite Orders",
  netbanking: "net-banking",
  offerDeals: "OFFERS & DEALS",
  outOfStock: "Out of Stock",
  placeOrder: "Place Order",
  playground: "playground",
  preparedBy: "PREPARED BY",
  processing: "PROCESSING",
  quickOrder: "Quick Reorder",
  reckOnText: "reckon you’ll want to order THIS again?",
  reorderBtn: "Order Again",
  rightArrow: "right arrow",
  savedOrder: "Saved this order in",
  searchMenu: "Search our menu",
  selectTime: "SELECT A TIME",
  signUpText: "Sign Up",
  socialIcon: "social icons view",
  startOrder: "Start Order",
  takeMeHome: "Take Me Home",
  trackOrder: "Track Order",
  unselected: "unselected",
  updateCart: "Update Cart",
  useAddress: "Use this Address",
  viewOffers: "View",
  wantToKnow: "What would you like to know?",
  yourAllSet: "YOU’RE ALL SET",
  yourSearch: "Your search",
  DineInStore: "Walk-In the Store",
  SelectStore: "Select Store",
  aSecondText: "A SECOND.",
  addHopeLogo: "Add Hope Logo",
  addHopeText: "Our goal is to feed 20 million people by 2021.",
  addedToCart: "added to cart!",
  addressHint: "Entering text into the input field will trigger the suggestions of address",
  arrvingSoon: " is arriving now",
  atWithSpace: " at ",
  balanceText: "Balance:",
  browseStore: "Browse Store",
  bucketEmpty: "Oops ! looks like there is no order history for you. Lets start an order",
  buyGiftCard: "Buy Another Gift Card",
  cancelOrder: "SORRY, WE’VE HAD TO CANCEL YOUR ORDER.",
  cartAllHope: "All Hope",
  cartViewAll: "View All",
  clearSearch: "Clear Search",
  closeButton: "Close button",
  contactInfo: "CONTACT INFO",
  contactless: "contactless",
  delToastMsg: "Successfully Your Occasion Delete",
  deliveredAt: "DELIVERED AT",
  deliveryFee: "Delivery Fee",
  disposition: "disposition",
  downloadApp: "Download App",
  emptyExpiry: "Enter Expiry Date",
  errorButton: "Tap me to see an error handler",
  findOpenKfc: "Find Open KFC",
  foundDriver: "WE’VE FOUND YOUR DRIVER",
  giftCardnum: "Gift Card Number",
  goodEvening: "Good Evening",
  gstIncluded: "Total (GST INCLUDED)",
  information: "INFORMATION",
  invalidCard: "Please Enter a Valid Card Number",
  invalidName: "Invalid Name",
  itemUpdated: "ITEM UPDATED",
  keepShoping: "Keep Shopping",
  kfcGiftCard: "KFC gift card",
  letsgetcook: "LET’S GET COOKIN’",
  mealOptions: "REVIEW AND CUSTOMISE",
  myOccasions: "ORDER AGAIN",
  no_internet: "We're sorry, we're having trouble with your connection. Please check your WiFi or cellular service and try again.",
  notSelected: "not selected",
  orderLookup: "Order lookup",
  otherWallet: "other-wallet",
  permanently: "PERMANENTLY",
  phoneNumber: "Phone Number*",
  productItem: "Sorry, this food item is",
  refineItems: "Refine Items",
  reorderCaps: "REORDER",
  selectStore: "Select your store",
  signInToast: "Thank you for signing up! Happy to have you!",
  sorryUnaval: "Sorry, some items become unavailable.",
  storeClosed: "Sorry, %storeName% is currently closed. Please select a different store or order during working hours",
  twitterLink: "twitter link",
  unavailable: "Unavailable",
  upSellTitle: "We Think You’ll Love These",
  viewAllDeal: "View All Deals",
  viewAllMenu: "View All Menu",
  viewReceipt: "View Receipt",
  viewallFaqs: "View all FAQs",
  viewdetails: "View Details",
  walkInStore: "Pick up from the store",
  welcomeBack: "WELCOME",
  whenYouHere: "WHEN YOU’RE HERE.",
  yourAccount: "your account",
  CVVisinvalid: "CVV is invalid",
  DiscountText: "Discount",
  GoBackToCart: "and click Back to Cart to go back Cart section.",
  GoToHomePage: "Go to HomePage",
  KfcToYourCar: "KFC to Your Car",
  accountTitle: "ACCOUNT",
  businessDays: " BUSINESS DAYS",
  cartCheckout: "Checkout",
  cartIncluTax: "Delivery Fee",
  cartInfoText: "Menu pricing varies between order types.",
  cartSubTotal: "Subtotal",
  cartfaqtitle: "FAQ",
  changedPrice: "Items have changed price.",
  checkBalance: "Check Balance",
  closePopOver: "Tap me to close popover1",
  closedStatus: "CLOSED",
  couponCopied: "Success! Your coupon has been copied!",
  currentOrder: "CURRENT ORDER",
  deliveryInfo: "DELIVERY INFO",
  discountCode: "Discount Code",
  editItemText: "Edit Item",
  editQuantity: "EDIT QUANTITY",
  editorPickup: "Editor's Pick & Customer Favorite",
  emailAddress: "Email Address*",
  enterMessage: "Enter message here.",
  entrYourMail: "Enter your email",
  facebookLink: "Facebook link",
  failureretry: "Retry",
  fingerLickin: "Finger Lickin’ Got It! Added to your cart!",
  footer_links: "footer-links",
  getDirection: "Get Directions",
  giftErrTitle: "OH NO!",
  greetingGood: "GOOD",
  haveQuestion: "Still have a question?",
  instructions: "INSTRUCTIONS",
  invaidInputs: "Your order could not be found",
  keepBrowsing: "Keep Browsing",
  keepShopping: "Keep Shopping",
  makeItACombo: "MAKE IT A COMBO",
  nameExistMsg: "There is already another favourite with this name. Enter a different order name",
  nextLocation: "next location",
  noNearestKFC: "No nearest KFC store",
  noOrderFor12: "No orders have been placed in the past 12 months.",
  offerApplied: "Offer Applied",
  offersForYou: "OFFERS FOR YOU",
  openTomorrow: "Open Tomorrow at {{time}}",
  orderDetails: "order details",
  orderHistory: "Order History",
  orderItAgain: "ORDER IT AGAIN",
  orderReceipt: "Order Receipt",
  orderhistory: "Order History",
  outOfService: "Out Of Service",
  payCashTitle: "Cash on Delivery",
  pdpAddToCart: "Add to Order",
  personalInfo: "Personal Info",
  pleaseSelect: "Please Select",
  quickReorder: "Quick Reorder",
  savedAddress: "Saved Address",
  selectATopic: "Select a Topic",
  selectOption: "Select Your Options",
  signInButton: "Sign-in to see your saved addresses",
  signInSignUp: "Sign in / Sign up",
  signOutText1: "You’re signed Out.",
  signOutText2: "We’re gonna miss you.",
  signinButton: "Sign-in to see your saved addresses",
  singleResult: "Result for",
  social_icons: "social-icons",
  takeawayFrom: "Pick up From",
  takeawayInfo: "PICK UP INFO",
  thatNotRight: "THAT AIN’T RIGHT",
  tokenExpired: "Your session has expired. Please relogin or continue as guest.",
  wantToModify: "Want to add or modify? ",
  yourDelivery: "Your delivery by",
  yourLocation: "Your Location",
  FeedbackEmail: "kfcfeedback@yum.com",
  ScheduleOrder: "Schedule Order",
  addHopeHeader: "Donate ₹5.00 Tick to Add Hope.",
  addNewProduct: "Add new product",
  addToOccasion: "Add to Favourites",
  address2Error: "Please enter a valid address.",
  addressHeader: "ADDRESS HEADER",
  alreadyMember: "Already a member?",
  browseTheMenu: "Browse The Menu",
  buttonPopOver: "Tap me to show second popover",
  cartDownArrow: "downArrow",
  cartMinusGrey: "decrease quantity",
  cartRemoveAll: "Remove All",
  cartRighttick: "Right Tick",
  checkoutAlert: "This is an error alert — check it out!",
  contentButton: "Tap me to see a content button",
  continueToPay: "Continue to Payment",
  couponSuccess: "Success! Your coupon has been applied!",
  defaultString: "to order your favorite Chicken.",
  deleteAccount: "Delete Account",
  dineInOptions: "DINE IN OPTIONS",
  editOrderType: "edit order type",
  effectiveDate: "Effective Date:",
  emailHelpText: "Please enter a valid email address.",
  emptyCardName: "Enter Full Name",
  errorDeleting: "Error in deleting account",
  exclusiveDeal: "EXCLUSIVE DEAL",
  findingDriver: "Finding a driver before we start cooking...",
  generic_error: "Thank you for visiting. We are fixing this right away. Will be back soon. Meanwhile, please call +918042754444 to order your favorite Chicken.",
  giftCardTitle: "GIFT CARD",
  haveAQuestion: "Have a question?",
  invalidExpiry: "Invalid Expiry Date",
  invalidQRCode: "Invalid QR code would you like to explore nearby KFC store.",
  kfcRestaraunt: "KFC Restaurant",
  largeCarryBag: "Large Carry Bag",
  lastNameLabel: "Last Name",
  leaveatMyDoor: "Leave at my door",
  leftArrowCaps: "Left Arrow",
  mandatorynote: "Note: * Indicates required field",
  morePageTitle: "Web Title",
  nameThisOrder: "Order Name",
  occasionTitle: "Order Name",
  oneItemUnaval: "Item is unavailable.",
  onlinePayment: "If you have made online payment,",
  orderAccepted: "ORDER ACCEPTED",
  orderDateTime: "ORDER DATE & TIME",
  orderForLater: "Order for Later",
  orderOnTheWay: "ORDER ON THE WAY",
  orderPastTime: "We’re sorry, but your current order’s scheduled time has passed. Please reschedule your order time to continue.",
  orderReceived: "ORDER RECEIVED",
  paymentHeader: "PAYMENT",
  pdpUpsizeDesc: "Large chips & drink",
  phoneHelpText: "Please enter the valid mobile number.",
  questionForUs: "Question for us?",
  refundMessage: "Your order transaction has failed and your refund is being processing. Please contant us if you have any questions.",
  removeFavMenu: "Remove From Favourite Menu",
  roundTheClock: "24x7",
  saveThisOrder: "Save This Order",
  scheduleOrder: "Schedule Order",
  selectedSlide: "selected slide",
  spinnerButton: "Tap me to see a spinner",
  thatsAllRight: "THAT AIN’T RIGHT",
  tickToAddHope: "Tick to Add Hope.",
  useMyLocation: "Use My Location",
  welcomeBackTo: "WELCOME BACK TO ",
  yourCartEmpty: "YOUR CART IS EMPTY. LET'S START AN ORDER!",
  yourPastOrder: "Your Orders",
  Congratulation: "CONGRATULATIONS!",
  Page_Title_FAQ: "KFC FAQ",
  Page_Title_Faq: "KFC FAQ",
  accoundSetting: "Account Settings",
  accountFavPage: "Account - Favorites",
  addToFavourite: "Add to Favourite",
  bankTextHeader: "Bank",
  browsecategory: "browse categories",
  buttonTemplate: "Template button",
  callRestaurant: "Call Restaurant",
  cardNumberText: "Card Number*",
  cartMinusBlack: "decrease quantity by 1 for",
  checkoutFaster: "CHECKOUT FASTER",
  closeGiftClose: "Close CHECK YOUR GIFT CARD BALANCE dialog",
  comboSubHeader: "Would you like to make it a combo? Select one of the options below.",
  confirmChanges: "Confirm Changes",
  delBtnOccasion: "Delete this occasion",
  deliverycharge: "Delivery Fee",
  deriverArrived: "Deriver arrived",
  discardChanges: "Discard Changes",
  driverArriving: "DRIVER ARRIVING",
  editSelections: "EDIT SELECTIONS",
  emptyCouponMsg: "Enter your Coupon Code.",
  emptyOccasions: "You haven’t created any occasions yet",
  emptyOccassion: "Occasion name should not be empty",
  firstNameLabel: "First Name",
  giftcardNumber: "Gift Card Number*",
  giftcardTender: "giftcard",
  giveUsYourName: "GIVE US YOUR NAME OR ORDER NUMBER WHEN YOU'RE HERE.",
  googleApiError: "Sorry, Google location services are down. Please check your internet connection and retry.",
  insideYourMeal: "INSIDE YOUR MEAL",
  invalidEmailId: "Invalid E-mail id",
  invalidOrderId: "Not A Valid Order Number",
  kfcLocalOffers: "Select a kfc to see local offers",
  maxtextInitial: "You already have ",
  nameOnCardText: "Name on Card*",
  nationalOffers: "National Offers",
  noteItemsAdded: "Please note your items will be added to your cart.",
  occassionLabel: "Occasion Name",
  orderDelivered: "Order delivered",
  orderFailedMsg: "Input necessary messaging here. Ut in viverra tellus enean pharetra enim",
  outForDelivery: "Out For Delivery",
  pdpChooseStore: "Choose a store and order mode to view pricing and availability in your area.",
  pdpUpsizeTitle: "Upsize meal",
  plsReviewOrder: "please review your order",
  popOverButton1: "Tap me to see first popover",
  processingYour: "PROCESSING YOUR",
  readyForDineIn: "READY FOR DINE-IN",
  readyForPickup: "Ready for Pickup!",
  recaptchaLabel: "Recaptcha",
  rightArrowCaps: "Right Arrow",
  searchThisArea: "Search this area",
  secureCheckout: "Secure Checkout",
  selectCarryBag: "Select large carry bag",
  selectQuantity: "SELECT QUANTITY",
  startYourOrder: "START YOUR ORDER",
  subscribeEmail: "I want to know about the cool stuff at KFC on Email & SMS (I know I can unsubscribe anytime).",
  suggestionText: "Entering text into the input field will trigger the suggestions of search",
  switchToDineIn: "Switch to Dine-in",
  trackYourOrder: "Track Your Order",
  turnedNoResult: "returned no results",
  MultipleResults: "Results for",
  Page_Title_Cart: "KFC Cart",
  Page_Title_Help: "KFC Help",
  YourKFCLocation: "YOUR KFC RESTAURANT",
  addToFavourites: "add to favourites",
  cartAddMoreFood: "Add More Food",
  cartAddMoreMenu: "Add More Menu",
  cartOffersDeals: "Apply Promos & Rewards",
  categoriesImage: "Browse categories image",
  comboSubHeader1: "Would you like to make it a combo?",
  comboSubHeader2: "Select one of the options below.",
  completedOrders: "completed orders",
  continueAsGuest: "Continue As Guest",
  continueExplore: "continue exploring our menu option",
  continuePayment: "Continue to Payment",
  currentlyClosed: "is currently closed. Please select a different store or order during working hours.",
  delAddressTitle: "Are you sure you want to remove this occasion?",
  deliveredAround: "will be delivered around",
  deliveryAddress: "Delivery Address",
  deliveryOptions: "DELIVERY OPTIONS",
  doNotSellMyInfo: "Do not sell my personal information",
  editbtnOccasion: "EDIT FAVOURITE NAME",
  emptyCardNumber: "Enter Card Number",
  emptyCartBanner: "Empty Cart Banner",
  emptyPostalCode: "Enter Billing Postal Code",
  exclusiveOffers: "Sign In to See Exclusive Offers & Deals",
  exploreFoodItem: "Explore our various other food items",
  feedbackSuccess: "Success",
  giftCartMessage: "Message",
  giftPurchaseErr: "It seems there is some issue with the gift card purchase",
  invalidPhoneNum: "Invalid Phone number",
  itemUnavailable: "Unavailable",
  loadMoreFavMenu: "Load More Favourite Menu",
  mandatoryFields: " * all fields are required",
  myOccassionText: "My Occasions",
  nameOrderNumber: "GIVE US YOUR NAME OR ORDER NUMBER",
  newOffersForYou: "new offers for you!",
  otherWalletText: "Other Wallet",
  paymentdeclined: "Unfortunately, we are unable to process your payment right now. The payment has been declined by the payment provider.",
  processingOrder: "Processing your order. ready in just a second.",
  refundInitiated: "refund-initiated",
  refundinitiated: "refund-initiated",
  saveOrderFaster: "SAVE YOUR ORDERS AND CHECKOUT FASTER",
  savedAddressMsg: "Saved this order in My Favourite Menu.",
  searchAndFilter: "Search",
  selectOrderType: "Select Order Type",
  takeawayOptions: "PICK UP OPTIONS",
  termsConditions: "Terms and Conditions",
  unavailabeItems: "Sorry, items in your cart have become unavailable. If you wish to checkout, these unavailable items will be removed from your cart.",
  deliveryAddressLineLabel: "Apt / Suite / Floor (Optional)",
  viewMoreDetails: "View More Details",
  KfcToYourCarDesc: "Avoid the hassle of walking into crowded places. We'll come to you.",
  Page_Title_Login: "KFC Login",
  btnRemindMeLater: "Remind Me Later",
  cancelButtonText: "Cancel",
  carousalDisabled: "carousel view disabled",
  cartOffersForYou: "Offers & deals for you",
  checkGiftBalance: "CHECK BALANCE",
  confirmSelection: "Confirm Selection",
  confirmYourOrder: "CONFIRMING YOUR ORDER.",
  contactInfoTitle: "Contact Info",
  createKfcAccount: "Create a KFC Account",
  dismissSelection: "Dismiss selections",
  editPersonalInfo: "Edit Personal Info",
  emailPlaceholder: "Email*",
  emptyEmailErrMsg: "Enter recipient email",
  enterYourOrderNo: "Please Enter your order Number",
  estimatedArrival: "Estimated Arrival",
  feedbackHelpText: "Please enter your feedback.",
  getOccasionEmail: "Get occasional emails about site improvements or changes",
  giftCardPurchase: "gift-card-purchase",
  giftMessageTitle: "MESSAGE",
  lastNameHelpText: "Please enter your last name",
  listviewDisabled: "listview disabled",
  morePageSubTitle: "Web Sub Title",
  netbankingString: "Netbanking",
  occasionGiveName: "ADD FAVOURITE ORDER",
  onlinePaymentMsg: "a refund will appear on your original payment source within 7-10 business days.",
  orderReadyInJust: "ORDER. READY IN JUST",
  outOfStockNotify: "Sorry, items in your cart has become unavailable. Please review before checkout.",
  phonePlaceholder: "Phone Number*",
  previousLocation: "previous location",
  productListModal: "Open product list modal",
  recipientEmptErr: "Invalid recipient email",
  scheduleDelivery: "Schedule delivery",
  searchByLocation: "Search by State, City, or Zip",
  selectOrderTitle: "HOW WOULD YOU LIKE TO RECEIVE YOUR ORDER?",
  signAndSaveOrder: "Sign Up & Save Order",
  storeClosedTitle: "is currently closed.",
  submitButtonText: "Submit",
  switchToDelivery: "Switch to Delivery",
  switchToTakeaway: "Switch to Pick up",
  unselectCarryBag: "unselect large carry bag",
  viewOrderHistory: "View Order History",
  Page_Title_Offers: "KFC Deals and Offers",
  SignInToSeeOffers: "Sign In to see exclusive offers & deals",
  addItemToCartText: "Added item to the cart",
  cancelOrderRefund: "WE WILL REFUND YOUR PAYMENT IN FULL WITHIN ",
  cartError_explore: "Sorry, this food is ",
  cartLineItemImage: "lineItemImage",
  cashOnDeliveryMsg: "Sorry for the inconvenience, your order has been cancelled by our store.",
  closePaymentModal: "Close Select your Payment Dialog",
  deleteAccountText: "Your account has been deleted. We're gonna miss you.",
  dineInStoreClosed: "Sorry, dine-in is not currently available right now.",
  feedbackSuccessOk: "OK",
  firstNameHelpText: "Please enter your first name.",
  haveADiscountCode: "HAVE A DISCOUNT CODE?",
  invalidPostalCode: "Invalid Postal Code",
  invalidcardNumber: "Invalid Card Number",
  leaveatMyDoorDesc: "To protect you and our team, we practice contactless delivery. Your driver will leave the order at your door, knock, step away, and wait at a safe distance for you to collect your food.",
  locationDeniedMsg: "KFC would like to process your location data to find nearby restaurants, send local deals, rewards and news, and to personalize and localize or user experience as described in our Privacy Statement.",
  loveToHearFromYou: "We'd love to hear from you.",
  namevalidationmsg: "special characters are not allowed",
  noStoreTextDineIn: "OOps! Sorry, there are no stores available for Dine In.",
  oneCouponPerOrder: "You can only apply one coupon per order.",
  openProductFilter: "Open product filter",
  orderGettingReady: "WE’RE GETTING YOUR ORDER READY",
  phoneNumberStatic: "+918042754444",
  popoverDoneButton: "Done",
  postOrderAccepted: "ORDER ACCEPTED.",
  postOrderErrorMsg: "It seems there is some issue with the order status",
  priceChangeNotify: "Items in your cart have changed price.",
  refineItemsHeader: "Refine items",
  reorderFavourites: "receive special offers and REORDER YOUR FAVOURITES",
  saveOrderThankYou: "Thank you for signing up!",
  selectionNotSaved: "Your selections aren’t saved.",
  setManualLocation: "Set up Manually",
  surveyScreenTitle: "Survey",
  termsAndCondition: "Terms & Conditions",
  yourEmailHelpText: "Please enter your Email ID.",
  Page_Order_Details: "KFC - Order Details",
  Page_Title_Account: "KFC Account",
  bothChangeCartMain: "NO LONGER AVAILABLE / HAVE CHANGED PRICE.",
  bothChangeCartText: "ITEMS IN YOUR CART ARE",
  cartOffersAndDeals: "Offers & Deals",
  cartRecommendTitle: "Indulgent Add-Ons",
  changedItemOneItem: "Item have changed price.",
  clearCartAwareText: "please be aware that ",
  defaultCallMessage: "Meanwhile,",
  dineInNotAvailable: "Dine-in is not available would like to go for Pick up instead?",
  emptyFavouriteMenu: "You haven’t favorited any items yet",
  errorMessageClosed: "Sorry , the restaurant is closed on the date and time you have chosen . Choose another date and time",
  favouriteMenuTitle: "FAVOURITES",
  giftCardNumberText: "Gift Card Number*",
  invalidEmailErrMsg: "Invalid email.",
  invalidQRCodeError: "Invalid QR code, would you like to explore nearby KFC store",
  itemAddedToCartMsg: "Please note your items will be added to your cart.",
  messageplaceholder: "Leave a message for recipients here.",
  noTimeSlotsMessage: "Timeslots are not available right now",
  pdpRegularSizeDesc: "Regular chips & drink",
  pdpRgularSizeTitle: "Regular size",
  postOrderScheduled: "scheduled!",
  purchasefailuremsg: "It seems there is some issue with the Gift card purchase",
  readyInJustASecond: "READY IN JUST A SECOND.",
  restaurantHandling: "Delivery Fee",
  searchResultHeader: "results for",
  selectYourLanguage: "Select Your Language",
  somethingWentWrong: "Something went wrong please try after sometime",
  storeUseMyLocation: "Use My Location",
  unsupportedBrowser: "This browser is not supported by KFC App. Please download these browsers to use this app.",
  userRefreshWarning: "Your session is going to expire soon. Please continue your work once your page reloads",
  vehicleInformation: "Enter your vehicle information (brand, color, etc)",
  viewMapErrorButton: "View Map",
  weThinkYouLoveThis: "We Think You'll love these",
  MyDeliveryAddresses: "MY DELIVERY ADDRESSES",
  Page_Title_Checkout: "KFC Checkout",
  Page_Title_Our_Adds: "KFC Our Adds",
  Page_Title_Sign_out: "KFC Signout",
  address2Placeholder: "Apartment, suite, unit, building, floor",
  bothChangeCartQuery: " DO YOU WANT TO KEEP THESE SETTINGS?",
  categoriesImageText: "Browse categories",
  changeOrderSettings: "Change Order Settings",
  clearCartActionText: "your cart will be cleared ",
  createAccountToSave: "CREATE AN ACCOUNT TO SAVE YOUR ORDERS AND CHECKOUT FASTER",
  creditDebitCardText: "Credit / Debit Card",
  defaultCallMessages: "please call",
  defaultErrorMessage: "Thank you for visiting. We are fixing this right away. Will be back soon.",
  deleteOccassionText: "Delete this Occassion",
  deliveryAddressText: "DELIVERY ADDRESS",
  deliveryInstruction: "Please Enter Delivery Instruction",
  deliveryStoreClosed: "Sorry, delivery is not currently available right now.",
  doubleTapToActivate: "double tap to activate",
  emptyFullNameErrMsg: "Enter your full name.",
  emptyYourNameErrMsg: "Please enter your name.",
  favoriteItemMessage: "Item added to favorites",
  findClosestLocation: "Find your closest location.",
  giftCardInformation: "GIFT CARD INFORMATION",
  giftCardPurchageMsg: "Your gift card has been purchased and details emailed to the recipient",
  insufficientBalance: "Insufficient Balance",
  lastNamePlaceHolder: "Last Name*",
  locationDeniedTitle: "Please Let us Use your location.",
  noStoreTextTakeaway: "OOps! Sorry, there are no stores available for Pick up.",
  occassionNameExists: "Occasion name already exists",
  pdpAllergyNutrition: "Allergy & Nutritional information",
  phcWheelChairAccess: "Wheel chair access",
  pleaseEnterLocation: "Please enter your location",
  removeFromFavourite: "Remove from Favourite",
  seeFullOrderHistory: "See Full Order History",
  selectOrderSubTitle: "Menu availability and pricing may vary between order types.",
  splahScreenGreeting: "NICE MEETING YOU",
  takeawayStoreClosed: "Sorry, pick up is not currently available right now.",
  unavailableCartMain: "NO LONGER AVAILABLE",
  unavailableCartText: "SORRY, SOME ITEMS ARE",
  unsuccessfulPayment: "It seems there is some issue with the order status",
  usernameplaceholder: "Your Name*",
  Page_Title_ContactUs: "KFC Contact Us",
  Page_Title_Gift_Card: "KFC Gift Card",
  Page_Title_Not_Found: "KFC Page not found",
  changeYourOrderTitle: "CHANGE YOUR ORDER",
  deliveryInstructions: "Enter delivery instructions (Optional)",
  dispositionUnavalMsg: "Sorry, %disposition% is currently unavailable. Please change your order settings below to complete your order.",
  editorPickupSubTitle: "Receive Editor updates on new and upcoming releases and the best reviews from customers like you",
  errorMessageInactive: "Damn! We can’t check out your order, keep trying or alternatively please visit the store.",
  favoriteStoreMessage: "This store is marked as your favorite",
  findNearByRestaurant: "Find nearby restaurant",
  firstNamePlaceholder: "First Name*",
  invalidAddressHeader: "Sorry, we could not identify your address. Please be more specific with your location.",
  largeCarryBagContent: "₹5.00 Tick to add a large carry bag.",
  myFavouriteMenuTitle: "My Favorite Menu",
  optionalEmailAddress: "Email Address",
  orderTakeAwayBtnText: "Order Pick up",
  priceChangedCartMain: "CHANGED PRICE.",
  priceChangedCartText: "ITEMS IN YOUR CART HAVE",
  saveToFavouriteOrder: "Save to Favourite Orders",
  scheduleForYourOrder: "Schedule for your order",
  selectYourBankHeader: "Select Your Bank",
  suggestedSearchTerms: "Suggested Search Terms",
  surveyScreenQuestion: "How was your order?",
  takeawayNotAvailable: "Pick up is not available would like to go for Dine-in instead?",
  unavailableCartQuery: "AT THIS LOCATION. DO YOU WANT TO KEEP THESE SETTINGS?",
  useMyLocationBtnText: "Use My Location",
  useremailplaceholder: "Your Email*",
  userphoneplaceholder: "Your Phone Number*",
  willBeReadyForPickup: "Will be ready for pick up by",
  Page_Title_Post_Order: "KFC Post Order",
  Page_Title_TermsOfUse: "KFC Terms of use",
  addHopeSubDescription: "Our goal is to feed 20 millions meals by 2021.",
  addresss2InvalidError: "Special characters are not allowed except ,/#@-().",
  billingPostalCodeText: "Billing Postal Code*",
  checkGiftBalanceTitle: "Check your Gift card balance",
  clearCartCompleteText: "to complete this order.",
  editCurrentRestaurant: "edit your kfc restaurant",
  editSelectionsBtnText: "Edit selections",
  invalidFullNameErrMsg: "Invalid full name.",
  maxOrderAmountMessage: "The max order amount for store is",
  minOrderAmountMessage: "The min order amount for store is",
  myFavouriteBrowseMenu: "Browse the menu",
  pleaseReviewYourOrder: "Please review your order",
  priceChangedCartQuery: " DO YOU WANT TO KEEP THESE SETTINGS?",
  purchasefailureheader: "OH NO!",
  searchDiffAddressText: "Search for a different address",
  storeClosedButtonText: "Store Closed",
  testingLingualSupport: "English",
  unFavoriteItemMessage: "Item removed from favorites",
  wantToKnowPlaceholder: "Type your message here.",
  NoBasketIdErrorMessage: "We were not able to fetch your cart details due to an unexpected error. To continue further please select the store to continue.",
  OccasionNameValidation: "Name cannot contain special characters",
  addPaymentMethodHeader: "Add Payment Method",
  cartCouponErrorMessage: "Sorry, this code isn’t available right now.",
  connectWithASpecialist: "Connect with a specialist for answers.",
  emptyPhoneNumberErrMsg: "Enter your phone number.",
  feedbackSuccessMessage: "Thanks for submitting your query. We will get back soon.",
  giftcardpaymentfailure: "Unfortunately, we can't process this payment, as the payment has been declined by your credit card Issuer or bank",
  myFavouriteMenuNoItems: "You haven't favorited any items yet",
  myOccassionUnavailable: "You haven't added any favourite orders yet",
  orderNumberPlaceHolder: "Order Number*",
  placePinAtYourLocation: "Place the pin at your location.",
  selectYourWalletHeader: "Select Your Wallet",
  storeClosedServerTitle: "can no longer serve this order.",
  tickToAddLargeCarryBag: "Tick to add a large carry bag.",
  unFavoriteStoreMessage: "This store is removed from your favorites",
  addressSuggestionHeader: "Does this address look correct?",
  closeStoreModelSubTitle: "Please select a different store or order during working hours.",
  dineInPickDifferentTime: "Dine-In is not available for the selected time, please select different time.",
  emptySearchResultHeader: "Your search did not end up in any results",
  invalidCharactersErrMsg: "Numbers and special characters are not allowed.",
  invalidYourEmailErrText: "Please Enter Correct Email Address",
  lookingForSpecificOrder: "Looking for a specific order?",
  pickupPickDifferentTime: "Pick up is not available for the selected time, please select different time.",
  savedOrderScheduleOrder: "Scheduled Order ",
  surveyScreenSubQuestion: "Write a review",
  Page_Title_Cart_Checkout: "KFC Checkout",
  communicationPreferences: "Communication Preferences",
  editOccassionDialogTitle: "Edit Occasion Name",
  enterQuestionPlaceholder: "| Enter question or search term",
  enterYourDeliveryAddress: "Enter your Delivery Address",
  invalidPhoneNumberErrMsg: "Invalid phone number.",
  kfcSignInExclusiveOffers: "Sign in to see more exclusive offers & deals",
  noStoresWithDineInHeader: "Sorry, dine-in is not currently available for this address.",
  noStoresWithPickupHeader: "Sorry, pick up is not currently available for this address.",
  phonenumberEmptyHelpText: "Please enter your phone number.",
  savedOrderInFavoriteMenu: "Saved this order in My Favorite Menu.",
  Page_Title_Payment_Status: "KFC Payment Status",
  Page_Title_Privacy_Policy: "KFC Privacy Policy",
  deliveryPickDifferentTime: "Delivery is not available for the selected time, please select different time.",
  doubleTaptoStartYourOrder: "double tap to open start your order page",
  giftcardCheckbalnaceTitle: "CHECK YOUR GIFT CARD BALANCE",
  invalidPhoneNumberErrText: "Not a valid phone number",
  invalidVehicalInformation: "Invalid Vehicle Information",
  multipleCustomizationText: "This item has multiple customizations added. Proceed to cart to remove item?",
  recipientemailplaceholder: "Recipient Email*",
  Page_Title_Payment_Failure: "KFC Payment Failure",
  Page_Title_Payment_Success: "KFC Payment Success",
  createAndAccountSaveOrders: "CREATE AN ACCOUNT TO SAVE YOUR ORDERS AND",
  dineInNoStoresFoundMessage: "No restaurant has been found for Dine-In. Please try another location.",
  dineInUnavailableErrorText: "Dine-In is currently unavailable for your location. Would you like to order pick up instead?",
  invalidDeliveryInstruction: "Invalid Delivery Instruction",
  invalidPhoneErrforGiftCard: "Invalid Phone Number, Please enter valid Phone Number",
  noStoresWithDeliveryHeader: "Sorry, delivery is not currently available for this address.",
  paymentPreValidationFailed: "Unfortunately, we are unable to process your payment right now. Please try with a different payment option.",
  pickupNoStoresFoundMessage: "No restaurant has been found for Carryout. Please try another location.",
  saveOrderAndCheckoutFaster: "SAVE YOUR ORDERS AND CHECKOUT FASTER",
  unidentifiedAddressMessage: "Sorry, we could not identify your address. Please be more specific by moving the map.",
  Page_Title_Terms_Conditions: "KFC TERMS & CONDITIONS",
  closeStoreModelSubNearTitle: "Please find another nearby restaurant.",
  enterYourOrderNoPlaceHolder: "Enter Your Order Number",
  recipientEmptyEmailHelpText: "Please enter the Recipient's Email ID.",
  selectYourOtherWalletHeader: "Select Your Other-Wallet",
  takeAwayUnavalibleErrorText: "This KFC is not accepting online orders. Please try another KFC near you or check back later.",
  cartRemoveSingleItemNextText: "from your cart?",
  cartRemoveSingleItemPrevText: "Are you sure to remove",
  deliveryNoStoresFoundMessage: "Hey, the nearest KFC store to your location is currently not accepting online orders. Please try another location or check again later.",
  deliveryUnavailableErrorText: "Delivery is currently unavailable for your location. Would you like to order pick up instead?",
  invalidRecipientEmailErrText: "Please Enter Correct Email Address",
  suggestionlocationTextPickup: "Suggested locations",
  areYouSureToDeleteAccountText: "Are you sure you want to delete your account?",
  cartRemoveAllConfirmationtext: "Are you sure to remove all of items in your cart?",
  selectYourPaymentScreenHeader: "Select Your Payment",
  cartError_sorryFoodNotAvailable: " currently, continue exploring.",
  noStoresWithDeliveryHeaderError: "Delivery is currently unavailable for your entered location. Could you be more specific with address or would you like to try pickup instead?",
  cartEditLineItemConfirmationtext: "You have successfully edited an item in the cart.",
  pleaseEnterYourVehicalInformation: "Please Enter Your Vehicle Information",
  cartRemoveLineItemConfirmationtext: "Item has been removed from your cart.",
  takeAwayUnavalibleErrorTextWithCTA: "Pick up is currently unavailable for your location. Would you like to try a different address?",
  addressBoxPlaceHolderForSearchStore: "Search by Suburb or Postcode",
  deliveryUnavailableErrorTextWithCTA: "Sorry, we could not identify your address. Please be more specific with your location.",
  dineInStoresWithoutAnyServiceHeader: "Sorry, dine-in is not currently available right now. Would you like to schedule for later?",
  pickupStoresWithoutAnyServiceHeader: "Sorry, pick up is not currently available right now. Would you like to schedule for later?",
  deliverystoresWithoutAnyServiceHeader: "Sorry, delivery is not currently available right now. Would you like to schedule for later?",
  noKFCNearYou: "Sorry, there is no KFC near you",
  sorryText: "sorry,",
  emergencyStoreCloseMain: "is currently closed due to unforseen circumstances",
  emergencyStoreCloseContent: "Find another nearby restaurant or\n close to keep browsing the menu",
  storeOfflineMain: "can no longer serve this order.",
  storeOfflineContent: "Please find another nearby restaurant.",
  storeCloseSoonMain: "is closing in 45 minutes",
  storeCloseSoonContent: "Complete your order and checkout within\n 15 minutes, or find another nearby store.",
  findNearByStore: "Find nearby store",
  customise: "Customise",
  editItemSuccessText: "You have successfully edited an item in your cart.",
  TotalOver100Text: "Whoops Total order is over $100",
  viewAllOfferText: "view all offer",
  completeOrderButtonText: "Complete order",
  scheduledTime: "Scheduled time",
  Locator: "Locator",
  includedToppings: "included toppings",
  extraToppings: "extra toppings",
  recipe: "Recipe",
  extras: "Extras",
  calories: "calories",
  onChangeWelcomeBack: "Welcome Back!",
  keepPrevOrderSettings: "WOULD YOU LIKE TO KEEP Your PREVIOUS order SETTING?",
  orderFor: "Order for",
  yesKeepIt: "Yes, Keep It",
  location: "Location",
  storeUnavailableForPickup: "Pick Up from this store is currently unavailable, change to Delivery for this store to fulfill your order.",
  storeUnavailableForDelivery: "Delivery from this store is currently unavailable, change to Pick Up for this store to fulfill your order.",
  dismissChangesAlert: "Your selections aren’t saved.",
  dismissSelections: "Dismiss selections",
  itemNotAvailable: "Items in this order are not currently available at this store right now.",
  browseMenuTitle: "Browse the selected restaurant menu.",
  welcomeBackText: "Welcome Back",
  browseMenuHeader: "BROWSE MENU CATEGORIES",
  storeCloseDeliveryOrderMode: "Delivery from this store is currently unavailable, change to Pick Up for this store to fulfill your order.",
  storeClosePickupOrderMode: "Pick Up from this store is currently unavailable, change to Delivery for this store to fulfill your order.",
  BuildYourOwnBucket: "Build Your Own Bucket",
  seeCustomisedItems: "See customised items",
  GSTincluded: "GST Included",
  cartSummaryNote: "Note: Any eligible promos, rewards and discounts will be applied at the next step before placing your order.",
  totalOrderErrorOverlimit: "Whoops Total order is over",
  totalOrderErrorBetweenlimit: "Whoops total order is not between",
  dropdownText: "Language",
  cancelSelection: "Cancel selections",
  signInToAccount: "SIGN IN TO YOUR ACCOUNT",
  continueAsGuestCheckout: "Continue as a Guest",
  letUsUseUrLocation: "PLEASE LET US USE YOUR LOCATION.",
  saveChanges: "Save changes",
  seeIncludedItems: "See included items",
  inExtrasText: "in Extra's",
  cartEditLineItemConfirmationtextMessage: "You have successfully edited an item in your cart.",
  deliverToYou: "%storeCount% KFC that deliver to you",
  savedAddresses: "Saved Addresses",
  thatDeliverToYou: "KFC that deliver to you",
  BrowseStoreMenu: "Browse store menu",
  locationDeniedTitleCaps: "PLEASE LET US USE YOUR LOCATION.",
  trackOrders: "Track Orders",
  estimatedarrival: "Estimated arrival",
  free: "Free",
  storeContainerText: "Let’s order for Takeaway or delivery",
  chooseAStore: "Choose a Store",
  backtomenu: "Back to menu",
  cutomizeYour: "CUSTOMISE YOUR",
  previousOrderDataSettingMsg: "WOULD YOU LIKE TO KEEP Your PREVIOUS order SETTING?",
  SERVES_TEXT: "Serves",
  confirmSelections: "Confirm Selections",
  continueAsAGuest: "Continue as a Guest",
  signInToYourAccount: "Sign in to Your Account",
  orderSummary: "ORDER SUMMARY",
  paymentOptions: "payment options",
  chooseAnotherWay: "Choose another way to pay",
  signInAccount: "SIGN IN TO YOUR ACCOUNT",
  emptyFirstNameErrMsg: "Enter your first ame",
  invalidFirstNameErrMsg: "Invalid first name.",
  emptyLastNameErrMsg: "Enter your last name",
  invalidLastNameErrMsg: "Invalid last name.",
  notavailable: "Not available",
  cartGstIncluded: "GST Included",
  cartSubText: "Any eligible discounts will be applied at the next step before placing your order.",
  viewOur: "View our",
  termsOfUse: "Terms of use",
  and: "and",
  privacy: "Privacy",
  changeStore: "Change your store settings",
  noLongerServeText: "Can No Longer Serve This Order.",
  selectDifferentStore: "Please select a different restaurant or keep browsing the menu",
  findNearRestorant: "Find nearby restaurant",
  viewour: "View our",
  termsofuse: "Terms of use",
  addContactToEnablePayment: "Please add your Contact details above to enable adding a Payment Method.",
  infoMakeSureRightNumberEmail: "Please make sure this is the right number and email address, just in case we need to contact you for this order. We won't spam you, promise.",
  continueToMyCart: "Continue to My Cart",
  itemAddedToOrder: "Item(s) added to order",
  clickPlaceOrderConfirmAgree: "By clicking on a Place Order, you confirm that you agree to our",
  legalInfoText1: "The average adult daily intake is 8700kJ.",
  legalInfoText2: '^ Pepsi Max, Pepsi, Pepsi Freeze & Mountain Dew Freeze contains caffeine. Mountain Dew Freeze is not recommended for children, pregnant or lactating women or individuals sensitive to caffeine.\r\n All product pricing shown is for the selected restaurant. Pricing may also vary between Pick Up and Delivery ("order modes") and will update automatically when switching between order modes.',
  locationBlockedError: "You have blocked from KFC accessing your location. Go to your Browser settings and enable %kfcUrl% to Use My Location.",
  kfcUrl: "kfc.com.au",
  deliveryPartnersDoordash: "doordash",
  endingIn: "Ending in",
  myFavStores: "MY FAVOURITE STORES",
  "delete": "Delete",
  orderAgain: "Order Again",
  reviewOrder: "Review Order",
  copyRight: "Copyright © KFC Australia. 2023 All Rights Reserved. Version {{appVersion}} ({{buildNumber}}) QA Environment",
  pickupTitle: "PICKUP SUPPORT",
  deliveryTitle: "DELIVERY SUPPORT",
  maxBucketToast: "A max bucket value of $100 to Checkout.",
  favouriteOrders: "Favourite Orders",
  editFavourite: "Edit Favourite Name",
  removeFavourites: "Remove from Favourites",
  secretMenuContext: "Discover unreleased treats that have never seen the light of day – until now... This menu is updated regularly so keep checking back!",
  whatSecretMenu: "WHAT SECRET MENU?!",
  unlock: "Unlock",
  ssshhh: "SSSHHH!",
  secretMenu: "secret menu",
  unlocksIn: "UNLOCKS IN",
  favouritesHeader: "Favourites",
  noAddress: "You don’t have any delivery addresses yet.",
  noFavStore: "You don’t have any favorite stores yet.",
  nameIsInvalid: "Name cannot contain special characters.",
  nameExistError: "There is already a saved address with this name.",
  addressErrorMsg: "Address Nickname can’t be the same as a previously saved address.",
  yesDelete: "Yes, Delete",
  addressUpdated: "Address Updated",
  addressSaved: "Address Saved",
  "default": "Default",
  deliveryAddressDeleted: "Delivery Address Deleted",
  deleteConfirmMsg: "Are You Sure you Want TO Delete this Delivery Address?",
  removedFromFavouriteStores: "Removed from Favourite Stores",
  viewInFavourites: "View in Favourites",
  occasionEditName: "Edit Order Name",
  addedToYourFavourites: "Added to Your Favourites",
  changedYourMind: "changed your mind?",
  clearSearchOrderName: "Clear search order name button",
  unavailableUppercase: "UNAVAILABLE",
  enterOrderName: "Please enter your order name.",
  enterDifferentOrderName: "There is already another favourite with this name. Enter a different order name.",
  cannotContainSpecialChar: "Name cannot contain special characters.",
  cancelPickupOrder: "ARE You Sure you WANT TO CANCEL YOUR PICK UP ORDER?",
  readyToStartCooking: "Are you sure you’re ready for us to start cookin'?",
  confirmYouAreHereText: "Confirm you’re here after you arrive so we can freshly prepare your order and keep everyone safe and contact-free.",
  receiveSpecialOffersText: "RECEIVE SPECIAL OFFERS AND REORDER YOUR FAVOURITES",
  fullPaymentRefund: "Full payment will be refunded within 3-5 business days.",
  editOrderName: "EDIT ORDER NAME",
  orderName: "Order Name",
  orderNameEditBox: "Order name edit box",
  inStore: "In Store",
  pickupInsideRestaurant: "Pick up your order at the counter inside the restaurant",
  pickupFromWindow: "Pick up your order from the Drive Thru collection window.",
  keepOrder: "Keep Order",
  checkedInStatus: "checkedIn",
  sitTightCallOutText: "sit tight We’ll CALL OUT THE ORDER NUMBER OR YOUR NAME WHEN it’s READY",
  "quote OrderNumber": "QUOTE YOUR ORDER NUMBER #",
  driveThruCollection: "DRIVE THRU COLLECTION",
  inStoreCollection: "IN STORE COLLECTION",
  cancelOrderButtonText: "Cancel Order",
  weArePreparingMeal: "we’re preparing your meal",
  iAmHereText: "I’m Here",
  iAmElseWhereText: "I’m Elsewhere",
  sentToPosStatus: "sent-to-pos-completed",
  iAmInsideRestaurant: "I’m inside the restaurant",
  readyToPrepareMeal: "we’re ready to FRESHLY PREPARE YOUR finger lickIn’ meal.",
  iAmAtDriveThruQueue: "I’m at the Drive Thru queue",
  checInAtDriveThru: "CHECK IN when you’VE ARRIVED AT THE DRIVE THRU",
  selectPickupMethod: "SELECT YOUR PICK-UP COLLECTION METHOD",
  menuView: "Menu",
  secretMenuView: "Secret Menu",
  deliverySupport: "Delivery Support",
  pickUpSupport: "PickUp Support",
  backToCheckOut: "Back to Check Out",
  favouriteNameUpdate: "Favourite name updated",
  removedFromFav: "Removed from Favourites",
  removeFromFavOrdersMsg: "ARE YOU SURE TO REMOVE THIS ORDER FROM YOUR FAVOURITES?",
  open: "Opens at {{time}}",
  wereReadyToMakeYourOrder: "WE’RE READY TO MAKE YOUR ORDER",
  itsBusyAndItsTakingAWhileToFindADriver: "It’s busy and it’s taking a while to find a driver...",
  weveFoundDeliveryDriver: "WE’VE FOUND A DELIVERY DRIVER",
  wereMakingYourOrderFresh: "WE’RE MAKING YOUR ORDER FRESH",
  deliveryDriver: "DELIVERY DRIVER",
  hasAcceptedToDeliverYourOrder: "has accepted to deliver your order",
  IsOnHisWayToTheRestaurant: "is on their way to the restaurant",
  hasBeenDelayed: "has been delayed",
  isAlmostThere: "is almost there",
  weAreWorking: "We are working on",
  weAreWorkingYour: "We are working on your order",
  orders: "orders",
  now: "now",
  saveAddress: "SAVE THIS DELIVERY ADDRESS TO YOUR ADDRESS BOOK",
  saveAddressBtn: "Save Delivery Address",
  trackDelivery: "Track Delivery",
  currentOrders: "CURRENT ORDERS ",
  pastOrders: "past orders",
  deliveryOrder: "DELIVERY Order",
  hasBeenConfirmed: "has been confirmed for",
  pickupOrder: "PICKUP Order",
  readyToCollect: "Ready to collect",
  pickupMethods: "Pick Up Methods",
  makingOrderFresh: "we’re MAKING your order FRESH",
  postOrderErrorMsgAU: "Something hasn’t worked on Check Out. Payment has not been taken.",
  orderTypeDifferentError: "This previous order was $previousOrderType and your current session is for $currentOrderType, select Change to update if required below.",
  locationDifferentError: "This previous order and your current location are different, select Change to update your KFC Restaurant below.",
  itemCurrentlyUnavailable: "Item currently unavailable",
  isClosedDueTo: "is currently closed due to",
  noOrderHistoryMsg: "Your Bucket is empty. Let’s start an order!",
  favNameExistMsg: "There is already another favourite with this name.",
  clearOccasion: "Clear order name",
  viewProduct: "View Product",
  storeClosedError: "$storeName is currently closed. Change store below to find another restaurant.",
  readyToMakeOrder: "we’re ready TO MAKE YOUR ORDER",
  foundDeliveryDriver: "we’VE FOUND A DELIVERY DRIVER",
  addNewAddress: "Add New Addresses",
  name: "Name",
  mobileNumber: "Mobile Number",
  dateOfBirth: "Date of Birth",
  postcode: "Postcode",
  emailMarketing: "Email Marketing",
  subscribe: "Subscribe",
  unsubscribe: "Unsubscribe",
  unsubscribedToastMessage: "You have successfully unsubscribed",
  subscribedToastMessage: "You have successfully subscribed",
  on: "On",
  off: "Off",
  managePreferences: "Manage Preferences",
  accountSignOutMessage: "are You sure you want to sign out of your account?",
  deleteAccountMessage: "are you sure you want to delete your account",
  savedMessage: " Your information has been saved",
  sms: "WE JUST SENT YOU AN SMS",
  verificationMessage: "Please enter the verification code we just sent to:",
  codeExpireMessage: "Your code will expire in",
  resendCode: "Resend code",
  otpInvalidMessage: "Invalid verification code",
  codeExpiredMessage: "Your code has expired",
  verificationOTPLabel: "Verification code",
  firstNameErrorMessage: "Please enter a valid First Name",
  lastNameErrorMessage: "Please enter a valid last Name",
  mobileErrorMessage: "Please enter a valid phone number",
  postalcodeErrorMessage: "Please enter a valid Australian postcode",
  mobileNumberWithAstrick: "Mobile Number*",
  mobileToolTipMessage: "Phone number required for service based messaging around your order.",
  dobToolTipMessage: "For future birthday rewards on us! Once saved this cannot be changed.",
  noneditionable: "is not editable",
  dispositionItemNotAvailable: "Not available for ",
  savedAddressHeaderTitle: "My Stores & Addresses",
  updatedAddress: "Address Updated",
  savedAddressesText: "Address Saved",
  emptyFavStore: "You don’t have any favorite stores yet.",
  emptySavedStore: "You don’t have any delivery addresses yet.",
  deleteAddressConfirmation: "Are you sure you want to delete the delivery address?",
  deleteDeliverySaveAddress: "Delivery Address Deleted",
  defaultAddressName: "Address ",
  addressOne: "Address 1",
  addressNickNameOptional: "Address Nickname (optional)",
  removeTitle: "Remove from Favourites",
  specialCharErr: "Name cannot contain special characters",
  nameExistMsgSaved: "Address Nickname can’t be the same as a previously saved address.",
  inlineSavedAddressMsg: "There is already a saved address with this name.",
  postProcessIngGstIncluded: "Total (GST INCLUDED):",
  addressPlaceHolder: "My Stores & Addresses",
  isCheckedInCooking: "IS CHECKED IN AND COOKING",
  callOutWhenMealIsReady: "We'll call out the order number or your name when your finger lickin' meal is ready.",
  hasNowClosed: "HAS NOW CLOSED",
  orderNoLongerCheckedIn: "This order can no longer be checked in and your order will be cancelled.",
  lastOrderCheckInAt: "LAST ORDER CHECK IN at ",
  isClosingSoon: "is closing soon.",
  checkInAheadTime: "Please ensure you check in your order ahead of this time",
  addFavName: "ADD FAVOURITE NAME",
  addedToYour: "Added to Your",
  favourites: "Favourites",
  enterYourOrderName: "Enter Order name input field",
  canceled: "Cancelled",
  pickupCancalledOrder: "Your pickup order has been cancelled.",
  favouriteNameLengthError: "Favourite Name has to be atleast 3 char length",
  savedeliveryaddress: "Save Delivery Address",
  savetoaddressbook: "SAVE THIS DELIVERY ADDRESS TO YOUR ADDRESS BOOK",
  moreInfo: "More Info",
  aptSuiteFloor: "Apt / Suite / Floor",
  viewAllPromos: "View All Promos & Rewards",
  addToOrder: "Add to Order",
  kfcSignInExclusivePromos: "Sign In To See Exclusive Promos & Rewards",
  forMembersOnly: "For Members Only",
  promosRewards: "Promos & Rewards",
  chooseAnyProduct: "CHOOSE ANY OF THESE PRODUCTS",
  freeDeliverywithWickedWings: "Free Delivery with Wicked Wings",
  thatsAllForNow: "THAT’S ALL FOR NOW",
  checkBackAgain: "Check back again soon for new Promos and Rewards just for you",
  ordersNow: "orders now.",
  hasScheduled: "has scheduled",
  seePromosForYou: "SEE PROMOS FOR YOU",
  setLocation: "Set Location",
  onePromoApplied: "One promo applied, remove to add another",
  itemInCart: "Item in your cart",
  pickupPromotion: "Promotion is for Pick Up",
  deliveryPromotion: "Promotion is for Delivery",
  changePickup: "Change to Pick Up",
  changeDelivery: "Change to Delivery",
  noDeliveryErrorMsg: "can’t deliver to the address entered. Available delivery restaurants below.",
  savedDeliveryOptions: "Delivery Options",
  nickName: "nickName",
  addressValue: "address",
  floor: "floor",
  deliveryOptionsVal: "deliveryOptions",
  Instructions: "deliveryInstructions",
  pdpToastShowTime: "3000",
  addOnMsg: "Add-On(s) included in your order",
  driveThruQuote: "DRIVE UP AND QUOTE YOUR ORDER NUMBER, PICK UP FROM THE collection window AND Enjoy YOUR MEAL",
  MODALHEADERTEXT: "Customise Your",
  preparedByHeading: "Prepared by double tap to activate",
  savetoFav: "Save Favourite Order",
  yes_Remove: "Yes, Remove",
  review_Condition: "Please review the conditions below.",
  gotIt: "Got It",
  promosRemoveConfirmation: "Are you sure you want to remove this promo?",
  promosSuceesToastMessage: "Promo added to your Order",
  promosRemoveToastMessage: "Promo removed from Order",
  promosUnmetMessage: "Promo conditions unmet to Checkout:",
  promosUnmetSummaryMessage: "Promo conditions not met, view Promo/s in Cart for details.",
  cartSelectDifferentStore: "Please find another nearby restaurant.",
  inprogress: "In Progress",
  processingRefund: "Processing refund",
  viewing: "Viewing",
  pleaseEnterAValidFirstName: "Please enter a Valid First Name",
  pleaseEnterAValidLastName: "Please enter a Valid last Name",
  induldentAddOnsAddedMessage: "Item added to your Order",
  callKFCstore: "Call KFC store",
  openTomorrowWithoutAt: "Open Tomorrow",
  induldentAddOnsHeading: "Product Added! This goes great with...",
  noPaymentOptionAvailable: "No payment option available.",
  labelName: "Name",
  valideDayAndMonthRequired: "Valid Day, Month are required to submit",
  valideDayMonthAndYearRequired: "Valid Day, Month and Year are required to submit",
  otpCodeExpiredMessage: "Your code has expired!",
  exceededVerificationAttempts: "You’ve exceeded the maximum verification code attempts (3/3). Information has not been saved.",
  startNewOrder: "Start New Order",
  cateringToMenuNavTitle: "You are ordering from the catering menu, which means the regular menu isn't available",
  cateringToMenuNavContentMsg: "Starting a new order from the regular menu will remove any Catering menu items from your cart.",
  add: "Add",
  cateringText: "Catering",
  menuToCateringNavTitle: "You are ordering from the regular menu, which means the catering menu isn't available",
  menuToCateringNavContentMsg: "Starting a new order from the catering menu will remove any regular menu items from your cart.",
  bundleOptions: "Bundle Options",
  checkInAtInStore: "CHECK IN when you’VE ARRIVED IN STORE",
  loremIpsumDolorSitAmetConjuncivus: "LOREM IPSUM DOLOR SIT AMET CONJUNCIVUS",
  maxOrderPromo: "You have reached the maximum order amount for this Promo.",
  promo: "promo",
  checkoutNoSignInMessage: "Please Sign In or Sign Up above to add a Payment Method and Checkout.",
  ClosedDueTo: "Closed due to",
  openNow: "Open Now • until",
  until: "until",
  savedDeliveryAddress: "Saved your Delivery Address",
  cateringSchedule: "Catering Schedule",
  pickup: "PICK-UP",
  collectedAt: "Collected At",
  openTodayWithoutAt: "Open Today",
  oopsWentWrong: "Oops something went wrong!",
  retainCart: "Please add your food again to cart",
  signOutFailText1: "You’re signed out",
  signOutFailText2: "Kindly Sign In again",
  canNotDeliverErrorMsg: "can’t deliver to the address entered. Available delivery restaurants below.",
  notSignedIn: "Not Signed In",
  tradingHours: "Trading Hours",
  deliveryHours: "Delivery Hours",
  kfcWebAndApp: "KFC App/Web \n Lockup",
  getDirections: "Get Directions",
  hoursCap: "HOURS",
  amenities: "AMENITIES",
  present: "Present:",
  allergenPresentDetails: "Allergen is present in the product as an ingredient, food additive or processing aid.",
  trace: "May Contain:",
  allergenTraceDetails: "Allergen is stored at, or used to manufacture other items at, the site where the product (or one of its ingredients) is produced.",
  na: "N/A",
  nutrition: "Nutrition",
  allergens: "Allergens",
  nonAlaCarteAlertText: "See individual products of this meal for allergen information",
  nonAlaCarteAlertLink: "View Nutrition & Allergen Guide",
  cartCateringContentText: "Please select a later time or date, or contact the store by phone.",
  returnedNoResults: "returned no results",
  disclaimer: "Disclaimer",
  per_serve: "Per Serve",
  per_gram: "Per 100g",
  yourOrders: "YOUR ORDERS",
  nutrition_allergen: "Nutrition and Allergen Information",
  quantityDecreseText: "Decreases quantity by 1 item for",
  quantityIncreaseText: "Increases quantity by 1 item for",
  quantityUpdateText: "Quantity updated to",
  cateringCartErrorMsg: "Catering Orders require 24 hours advance notice to Checkout.",
  apiFailurePopupHeader: "SOMETHING WENT WRONG!",
  apiFailurePopupDescription: "Whoops, something went wrong! Please try again.",
  appCrashPopupHeader: "SOMETHING WENT WRONG!",
  appCrashPopupDescription: "Whoops, something went wrong! Please restart the app",
  networkIssuePopupHeader: "SOMETHING WENT WRONG!.",
  networkIssuePopupDescription: "We’re sorry, we’re having trouble with your connection. Please check your WiFi or cellular service and try again.",
  refunded: "Refunded",
  invalidCustomerInfoError: "Invalid customer details. Please update it from Account Settings page.",
  cateringPromoError: "Promotion not available with Catering orders",
  rdpRestroom: "Gender Neutral Restroom",
  rdpaccessibility: "Wheelchair Accessible",
  cateringOrder: "CATERING ORDER",
  thankYou: "THANK YOU",
  cateringConfirmationEmail: "An confirmation email has been sent and a store manager will contact you on Pick Up day to ensure its cooked at the exact right time",
  yourCatering: "YOUR CATERING ORDER WILL BE READY FOR PICKUP IN STORE",
  selectText: "You must select",
  addToYourOrder: "pieces in total to add this to your Order.",
  productUnavailable: "Product Unavailable",
  currentlyUnavailable: "Currently unavailable",
  scheduledPickup: "is scheduled to be picked up at",
  details: "Details",
  cartCateringAlertStartText: "Sorry, catering orders require 24 hours advance notice",
  cartCateringAlertEndText: "to checkout",
  someoneElseCollectingOrder: "someone else collecting the order?",
  informToContactNominatedPersonOrder: "We will only use this information to contact this nominated person about the order.",
  enterContactDetails: "Enter Contact Details",
  Order_Processing: "KFC Order Processing",
  Order_Summary: "KFC Order Summary",
  rdpNoDelivery: "Sorry! Delivery is not currently available for this store.",
  pushNotifications: "Push Notifications",
  "nutration-allergen-guide": "NUTRITION & ALLERGEN GUIDE",
  kfcFood: "KFC FOOD",
  PercentDailyValuesText: "*Percent Daily Values (DV) are based on a 2,000 calorie diet.",
  infoCorrectText: "Information correct as at May 2022",
  eneryKJText: "Energy (kJ)",
  cateringWarning: "Catering orders require Pick Up from the restauarant.",
  exploreCatering: "Explore Catering",
  thatsAllFolks: "That’s all folks",
  viewUp: "viewup",
  helpDropdown: "What can we help you with today?*",
  enquiryDropdown: "What is this KFC App Enquiry about?*",
  specificDropdown: "Can you be more specific?*",
  postcodeError: "Enter suburb or postcode",
  sortVisitError: "We ran into a problem. Please try again.",
  orderNumberError: "Enter your [X] digit order number",
  enquiryDetailsError: "Enter enquiry details",
  visitedDateError: "Enter ordered date",
  getTouch: "GET IN TOUCH",
  thankYouCommentMessage: "Your comments have been received and we will get back to you shortly",
  sitemapPageTitle: "KFC Sitemap",
  stores: "My Stores",
  otherPages: "Other Pages",
  yourCateringOrderWill: "YOUR CATERING ORDER WILL",
  beReadyForPickup: "BE READY FOR PICK UP IN STORE",
  kJ_text: "kJ",
  phoneStaticText: "What’s your phone number?",
  emailStaticText: "What’s your email address?",
  thanksStaticText: "Thanks",
  enquiryStaticText: "Please tell us any further details of your enquiry.",
  gladStaticText: "Glad I could help.",
  OK: "OK",
  willYouBeOrdering: "Which menu will you be ordering from today?",
  cateringMenu: "Catering Menu",
  storeMenu: "Store Menu",
  storeCloseText: "Store Closed",
  cateringClosedStoreMsg: "Uh oh, looks like this KFC store has closed, so you won’t be able to order here now.",
  dippingSauceId: "C-30055-prod",
  oldPrice: "Old Price",
  newPrice: "New Price",
  searchNutritionAllergen: "Search Nutrition & Allergen Guide",
  openAt: "Open at",
  technicalError: "Open Now (online ordering unavailable)",
  closingSoon: "Closing soon • until",
  open24Hr: "Open 24 Hour",
  cancelDeliveryOrderRefund: "WE WILL REFUND YOUR PAYMENT IN FULL WITHIN 07 BUSINESS DAYS",
  socialNetworkingBtn: "Social Networking Site ",
  setYourLocation: "Set Your Location",
  moreCrowdPleaser: "More Crowd Pleasers",
  deliveryIsCurrentlyUnavailable: "Delivery is currently unavailable",
  emptyPublicationDetailsErrMsg: "Enter publication details",
  reOrderAgain: "ORDER IT AGAIN",
  checkoutUnavailableAtStore: "Checkout currently unavailable at this store",
  outOfStockItemText: "An ingredient is currently unavailable. Please review the inclusions below before adding to order.",
  outOfStockProductText: "A product or ingredient is currently unavailable. Please review the required selections below to add to order.",
  ingredientUnavailable: "Ingredient unavailable",
  selectionRequired: "Selection required",
  customiseRequired: "Customise required",
  addonRemoved: "Product related Add Ons have also been removed from your order.",
  pdpRecipeIngredientUnavailable: "An ingredient has become unavailable, please review the meal options below before ordering.",
  emptyPhoneErrMsg: "Enter your phone number",
  search: "Search",
  findNearKFCText: "Find the nearest KFC for pickup & delivery: Search by Suburb or Postcode",
  enterYour: "Enter your",
  invalid: "Invalid",
  totalPriceErrorMessage: "Whoops Total order is over $",
  specialHours: "(Special Hours)",
  closedHours: "00:00",
  closedTime: "0000",
  pickUpTime: "PICK UP TIME",
  deliveryTime: "DELIVERY TIME",
  selectPickupTime: "Select pick up time",
  scheduledTimePassed: "Your scheduled time has passed, please select a new time to proceed.",
  breakfastMenu: "Breakfast menu available till 11am",
  addresses: "My Stores & Addresses",
  selectDeliveryTime: "Select delivery time",
  rescheduleOrderTime: "Reschedule",
  selectAnotherTime: "Select another time to receive your order.",
  deliveryLocation: "DELIVERY LOCATION",
  removeAllUnavailableItem: "Remove all unavailable items",
  menuKickedInUnavailableCart: "Lunch menu has kicked in",
  removeUnavailableItemsInCart: "remove unavailable items in cart",
  checkoutUnavailable: "Items in your cart are currently available. Please remove the items from your",
  toContinue: "to continue.",
  specialClose: "(Special Close)",
  scheduleTimeCrossed: "Your scheduled\n order time has passed",
  scheduledCaps: "SCHEDULED",
  deeplinkCategoryNotAvailable: "Sorry, THIS CATEGORY IS NOT AVAILABLE FOR THE SELECTED RESTAURANT.",
  promoAddToCart: "Add to Order",
  storesNotServingCurrently: "Sorry! Your store is not serving orders currently",
  myFavouritelabel: "MY FAVOURITE STORES",
  searchOurMenu: "Search our menu",
  changeLanguage: 'Change language',
  orderScheduled: 'ORDER SCHEDULED',
  storeClosedAndPickUpApplied: 'The store is currently closed, the next available pick up time has been applied',
  goodMorning: 'Good Morning',
  goodAfternoon: 'Good Afternoon',
  noKfcNearYou: "Sorry, there is no KFC near you",
  legalInfoPLPFooter1: "The average adult daily intake is 8700kJ.",
  legalInfoPLPFooter2: "^ Pepsi Max, Pepsi, Pepsi Freeze & Mountain Dew Freeze contains caffeine. Mountain Dew Freeze is not recommended for children, pregnant or lactating women or individuals sensitive to caffeine.",
  meetAtVehicle: "Meet at vehicle",
  couponErrMsgBSDE0022: "This coupon code is already redeemed.",
  couponErrMsgBSBR003: "This coupon code is incorrect.",
  monday: "monday",
  tuesday: "tuesday",
  wednesday: "wednesday",
  thursday: "thursday",
  friday: "friday",
  saturday: "saturday",
  sunday: "sunday",
  editAddress: "EDIT DELIVERY ADDRESS",
  signedOut: 'You’re signed Out. We’re gonna miss you.',
  kfcStore: 'KFC store',
  addressLabel: 'Address',
  postalCode: 'Postal Code',
  cityTown: 'City / Town',
  state: 'State',
  deliveryInstructionAddress: 'Delivery Instructions',
  makeDefaultAddress: 'Make this my default address',
  labelPostalCode: "Postal Code",
  thereNoFriedText: "THERE'S NO FRIED",
  chickenOnThisPage: "CHICKEN ON THIS PAGE",
  giftCardPurchaseSuccess1: "YOUR GIFT CARDS",
  giftCardPurchaseSuccess2: "ARE ON THE WAY",
  giftCardPurchaseMsg: "Your reciepients will recieve an SMS shortly.",
  returnToGiftCards: "Return to Gift Cards",
  tipExceedsSubtotal: 'Tip exceeds Subtotal',
  noResults: "RETURNED NO RESULT",
  serves: "Serves",
  myDeliveryAddresses: "MY DELIVERY ADDRESSES",
  yourorders: "YOUR ORDERS",
  orderAgainBtn: 'Order Again',
  quoteOrderNumber: 'QUOTE YOUR ORDER NUMBER #',
  cardValidatingTitle: 'VALIDATING',
  newCardText: 'NEW CARD',
  cardValidationDesc: "We're validating your card with payment provider",
  removeGiftCard: "REMOVE GIFT CARD",
  giftCardContent: 'Are you sure you would like to remove this Gift Card?',
  removeVoucher: 'REMOVE VOUCHER',
  voucherContent: 'Are you sure you would like to remove this Voucher?',
  giftCardMealFullyCovered: "Woohoo! Your Gift Card has covered your meal.",
  voucherMealFullyCovered: 'Woohoo! Your voucher has covered your meal.',
  voucherAboveSubtotal: 'Vouchers are single use. Balance above meal subtotal can not be used again.',
  giftCardAboveSubtotal: 'Woohoo! Your Gift Card has covered the meal. Use your remaining balance another time.',
  maxSubTotalValueCovered: 'Maximum order subtotal limit has been reached.',
  maxVoucherLimitExceeded: 'The maximum number of Gift vouchers has been applied.',
  giftCardToast: "Gift Card Removed",
  voucherToast: "Voucher Removed",
  giftCardVoucherContent: "The added vouchers/gift cards will be cleared if you update the cart. Do you want to continue?",
  removeGiftCardVoucher: "CLEAR VOUCHER/GIFT CARD",
  postOrderCouponFailure: "Your time to redeem a gift card or voucher has expired. Please re-apply at Cart and proceed to Checkout.",
  reApplyGiftCardOrVoucher: 'Please re-apply a valid gift card or voucher code to your order.',
  savedCardPaymentTitle: "Saved cards",
  otherPaymentTitle: "Use Other Payment Method",
  optionCurrentlyAvailable: "Option currently unavailable,",
  allowAllCookiesLink: "please allow all cookies",
  enableText: "here to enable",
  ordertaxpst: 'Order tax PST',
  deliverytaxhst: 'Delivery Tax HST',
  hst: 'HST',
  gst: 'GST',
  pst: 'PST',
  mealFullyCoveredDeliveryFeeRemaining: "Almost there! Just the Additional Charges remaining to Place Order.",
  deliveryOptionsToolTip: "Please select an item in the list.",
  aditionalAddress: "Apt / Suite / Floor (Optional)",
  creditCardDetails: "CREDIT CARD DETAILS",
  selectPaymentMethod: "Select Payment Method",
  notNow: "Not Now",
  other: "Other"
};
exports.translation = translation;